import DashboardHeader from "dashboard/DashboardHeader";
import React from "react";

export const Header = ({isGenai,disconnect}) => {
  return (
    <>
      <DashboardHeader isGenai={isGenai} disconnect={disconnect} />
    </>
  );
};
